
import { Vue, Component } from 'vue-property-decorator'
import Order from '@/types/order'
import OrderShowDetailsCard from '@/views/order/cards/OrderShowDetailsCard.vue'
import OrderShowConfigurationCard from '@/views/order/cards/OrderShowConfigurationCard.vue'
import ls from '@/ls'

@Component({
  components: { OrderShowConfigurationCard, OrderShowDetailsCard }
})

export default class OrderShow extends Vue {
  settings = {
    routeNames: { list: 'orders', show: 'orderShow', edit: 'orderEdit' },
    routeParamKey: 'orderId',
    functionNames: { setCurrent: 'setCurrentOrder', clearCurrent: 'clearCurrentOrder', save: 'saveOrder' },
    getterNames: { current: 'currentOrder', loading: 'loadingOrder' }
  }

  currentTab:string = ls.get('orderEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('customerEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Order {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
